import React from 'react';
import DataTable from 'react-data-table-component';

const CustomDataTable = ({ columns, data, title, actionButton, toolbarContent, ...tableProps }) => {
  const customStyles = {
    rows: {
      style: {
        minHeight: '45px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
        backgroundColor: '#f8f9fa',
        fontWeight: 'bold',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
      },
    },
  };

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body">
        {(title || actionButton) && (
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="mb-0">{title}</h5>
            {actionButton}
          </div>
        )}
        {toolbarContent && (
          <div className="mb-3">
            {toolbarContent}
          </div>
        )}
        <DataTable
          columns={columns}
          data={data}
          pagination
          customStyles={customStyles}
          striped
          responsive
          highlightOnHover
          pointerOnHover
          paginationRowsPerPageOptions={[10, 25, 50]}
          {...tableProps}
        />
      </div>
    </div>
  );
};

export default CustomDataTable;